module.exports = __webpack_public_path__ + "static/media/logo-light.84193f50.svg";